export default {
    'required': 'Required field',
    'diff_date_in_month': 'The dates must have a difference of no more than 12 months',
    'diff_date_in_three_month': 'Dates must be no more than 3 months apart',
    'task_is_timeless_at': 'Select the task creation period.'
}
